import { useEffect } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { SecondaryButton } from './SecondaryButton';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirming?: boolean;
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirming = false,
}: ConfirmModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 font-['DM_Sans',sans-serif]">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200"
        onClick={confirming ? undefined : onClose}
      />
      <div className="relative bg-white rounded-[20px] shadow-2xl w-full max-w-[420px] overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="p-6 pt-7 text-center">
          <h2 className="font-['Playfair_Display',sans-serif] font-extrabold text-[#3a3335] text-[22px] leading-[28px] mb-2">
            {title}
          </h2>
          <p className="text-[#908e8e] text-[14px] leading-[21px] mb-6">
            {message}
          </p>
          <div className="flex flex-col gap-3">
            <PrimaryButton
              onClick={confirming ? undefined : onConfirm}
              className={`w-full py-3 ${confirming ? 'opacity-60 pointer-events-none' : ''}`}
            >
              {confirming ? 'Please wait…' : confirmLabel}
            </PrimaryButton>
            <SecondaryButton
              onClick={confirming ? undefined : onClose}
              className={`w-full py-3 ${confirming ? 'opacity-60 pointer-events-none' : ''}`}
            >
              {cancelLabel}
            </SecondaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}
